import React, { useEffect } from "react";


export const ExeIntensity = (props) => {
    const { excsInfo, exeIdx } = props;
    
    return (
        <div>
            <div className="inly-sutit">운동 강도</div>
            <div className="select-cate-show">
                <div className="select-custom-box">
                    <a className="btn-select inb">천천히</a>
                    <ul>
                        {excsInfo[exeIdx].intensity.map((m, i) => (
                            <li key={"itst" + i}><a>{m.text}</a></li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};
